module.exports = __webpack_public_path__ + "static/media/alert_animated.5e67f041.gif";